var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('a',{attrs:{"href":"http://istay.io","target":_vm.target}},[_c('img',{attrs:{"src":require("@/assets/images/istay-orange-text.png"),"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }